import { createApp } from "vue";
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";

// Global components import

import HomeTopBar from "../../common/js/components/HomeTopBar.vue";

const app = createApp({});
app.use(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded

app.component("home-top-bar", HomeTopBar);

app.mount("#themeDefaultHome");

// @todo : uncomment this...

registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
